import Transactions from './transactions';

export default Transactions;
